export default __webpack_public_path__ + "static/media/CreateNewView.d27de967.svg";